import React, { useState, useEffect } from 'react';
import { message, Modal, Breadcrumb, Button } from 'antd';
import { ExclamationCircleOutlined, DashboardOutlined, PlusSquareOutlined } from '@ant-design/icons';
import StoreTable from '../../components/store/StoreTable';
import StoreModal from '../../components/store/StoreModal';
import { useGetAllStores, useCreateStore, useUpdateStore, useDeleteStore } from '../../hooks/store/storeQuery';
import Header from '../../components/dashboard/header';
import { Link } from 'react-router-dom';
import { MdOutlineInventory2 } from 'react-icons/md';

const { confirm } = Modal;

const StorePage = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [editingStore, setEditingStore] = useState(null);
  const [refreshFlag, setRefreshFlag] = useState(false);

  const { loading, stores } = useGetAllStores(refreshFlag);
  const createStore = useCreateStore();
  const updateStore = useUpdateStore();
  const deleteStore = useDeleteStore();

  const handleAdd = () => {
    setEditingStore(null);
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingStore(record);
    setModalVisible(true);
  };

  const handleDelete = (record) => {
    confirm({
      title: 'Are you sure you want to delete this store?',
      icon: <ExclamationCircleOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: async () => {
        try {
          await deleteStore(record.id);
          message.success('Store deleted successfully');
          setRefreshFlag(!refreshFlag);
        } catch (error) {
          message.error('Failed to delete store');
        }
      },
    });
  };

  const handleSubmit = async (values) => {
    try {
      if (editingStore) {
        await updateStore(editingStore.id, values);
        message.success('Store updated successfully');
      } else {
        await createStore(values);
        message.success('Store created successfully');
      }
      setModalVisible(false);
      setRefreshFlag(!refreshFlag);
    } catch (error) {
      message.error('Failed to save store');
    }
  };


  return (
    <>
      <div className="main-container">
        <Header />
        <div className="main-body">
          <div className="info-bar">
            <Breadcrumb>
              <Breadcrumb.Item>
                <DashboardOutlined className="dashboard-icon" />
                <Link to={"/dashboard"}>Dashboard</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <MdOutlineInventory2 />
                <Link to={"/dashboard/store"}>Store</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <PlusSquareOutlined />
                <Link to="/dashboard/store">Manage</Link>
              </Breadcrumb.Item>
            </Breadcrumb>
            <div style={{ display: 'flex', gap: '1em' }}>
              <Button
                type="primary"
                style={{ backgroundColor: "green", color: "#FFFFFF" }}
                onClick={handleAdd}
                icon={<PlusSquareOutlined />}
              >
                Create Store
              </Button>
              <Button
                type="default"
                onClick={() => window.location.href = "/dashboard/store-transactions"}
              >
                View Transactions
              </Button>
            </div>
          </div>
          <div className="table-section">
            <StoreTable
              stores={stores}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onAdd={handleAdd}
              loading={loading}
            />
          </div>
        </div>
      </div>
      <StoreModal
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onSubmit={handleSubmit}
        initialValues={editingStore}
        title={editingStore ? 'Edit Store' : 'Add Store'}
      />
    </>
  );
};

export default StorePage;
